export default class Orgao {
  constructor(
    id = null,
    nome = null,
    ativo = true,
    alteradoPor = null,
    cadastradoPor = null,
  ) {
    this.id = id
    this.nome = nome
    this.ativo = ativo
    this.alteradoPor = alteradoPor
    this.cadastradoPor = cadastradoPor
  }
}
